import {MinMaxRateValue} from './min-max-rate-component.domain';

export type BusinessOverdraftRateCardValue = BusinessOverdraftRateCard | null;
export interface BusinessOverdraftRateCard {
  // ZEN-818 follow-up: 3-tier model replaces base rate + (non-property / low-score) uplifts.
  // Tier membership is resolved by the calculator from property owner, Equifax director score
  // and GST (TIB) age inputs, so those uplifts are no longer stored on the rate card.
  tier1Rate: number,
  tier2Rate: number,
  tier3Rate: number,
  facilityFee: number,
  docFee: MinMaxRateValue,
  rbaRate: number,
}
